import { FC } from 'react';
import { useIntl } from 'react-intl';

import { isRuCluster } from '@/shared/lib';
import { DropdownSelect } from '@/shared/ui';

import {
  LABELING_COUNTRIES,
  LABELING_RU_CLUSTER_COUNTRIES,
} from '../../config';

import styles from './LabelingHeader.module.scss';

type LabelingHeaderProps = {
  country: string;
  onChange: (newValue: string | string[]) => void;
};

export const LabelingHeader: FC<LabelingHeaderProps> = (props) => {
  const { country, onChange } = props;

  const { formatMessage } = useIntl();

  const isRu = isRuCluster();

  const countries = isRu ? LABELING_RU_CLUSTER_COUNTRIES : LABELING_COUNTRIES;

  const countryLabel = isRu
    ? 'Страна'
    : formatMessage({ id: 'global.country', defaultMessage: 'Country' });

  const selectCountryText = isRu
    ? 'Выберите страну'
    : formatMessage({
        id: 'labeling.selectCountry',
        defaultMessage: 'Select country',
      });

  return (
    <DropdownSelect
      label={countryLabel}
      onChange={onChange}
      value={country || selectCountryText}
      options={countries.map((countryOption) => ({
        label: countryOption,
        value: countryOption,
      }))}
      className={styles.select}
      icon="arrow2"
    />
  );
};
